import { render, staticRenderFns } from "./GuideStation.vue?vue&type=template&id=5070a0ac&scoped=true&"
import script from "./GuideStation.vue?vue&type=script&lang=js&"
export * from "./GuideStation.vue?vue&type=script&lang=js&"
import style0 from "./GuideStation.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GuideStation.vue?vue&type=style&index=1&id=5070a0ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5070a0ac",
  null
  
)

export default component.exports